
class CategoryCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector('.category-swiper');
  }

  connectedCallback() {
    new Swiper(this.swiperEl, {
      direction: 'horizontal',
      freeMode: true,
      centerInsufficientSlides: true,
      spaceBetween: 18,
      mousewheel: {
        invert: false,
        forceToAxis: true
      },
      breakpoints: {
        320: {
          slidesPerView: 1.3,
        },
        400: {
          slidesPerView: 1.7,
        },
        520: {
          slidesPerView: 2.2,
        },
        750: {
          slidesPerView: 3.5,
        },
        990: {
          slidesPerView: 4.2,
        },
        1508: {
          slidesPerView: 4.2,
        },
        1920: {
          slidesPerView: 4.175,
        },
      },
      on: {
        init: () => {
          this.swiperEl.classList.remove('hidden')
        },
      }
    })
  }
}

window.customElements.define('category-carousel', CategoryCarousel);
